module.exports = __webpack_public_path__ + "img/202105-group.f2ae7a5a.jpg";